import { useSelector } from 'react-redux';

const API_URL = process.env.REACT_APP_API_URL ?? '';
const MAX_BYTES = 10 * 1024 * 1024;

export const PREUVE_ACCEPT = 'image/png,image/jpeg,application/pdf';

export const preuveUri = (priere) => (priere?.preuveUrl ? `${API_URL}${priere.preuveUrl}` : null);

// Auteur de la janaza ou admin
export function useCanManagePreuve(priere) {
  const user = useSelector((s) => s.auth.user);
  if (!priere || !user) return false;
  if (['admin', 'superadmin'].includes(user.role?.toLowerCase())) return true;
  return user.dbId != null && String(priere.utilisateurId) === String(user.dbId);
}

// Renvoie la clé de traduction de l'erreur, ou null si le fichier est accepté
export function validatePreuveFile(file) {
  if (!file) return null;
  if (!PREUVE_ACCEPT.split(',').includes(file.type)) return 'preuve.error_type';
  if (file.size > MAX_BYTES) return 'preuve.error_size';
  return null;
}

// Le serveur répond en français : on traduit d'après le statut
export function uploadErrorKey(err) {
  const status = err?.response?.status;
  if (status === 413) return 'preuve.error_size';
  if (status === 400) return 'preuve.error_type';
  return 'preuve.error_upload';
}
